import styled from 'styled-components';

import theme from '../../../utils/theme';

import { IPanelProps } from './types';

export const PanelWrapper = styled.div<IPanelProps>`
  border-radius: var(--space-xl);
  border: ${(props) => (props.hasBorder ? '1px' : 0)} solid
    ${theme.colors.lightGrey};
  overflow: ${({ allowOverflow }) => (allowOverflow ? 'visible' : 'hidden')};
  position: relative;
  padding: ${(props) => (props.hasPadding ? 'var(--space-m)' : 0)};
  z-index: 1;
  background-color: ${(props) =>
    props.variant ? theme.colors[props.variant] : 'transparent'};
`;
